export default __webpack_public_path__ + "assets/images/92796475c56a8a614230a77856eac5bd.png";